import React from "react";
import { Dropdown } from "react-bootstrap";
import DropdownButton from "react-bootstrap/esm/DropdownButton";
import MenuSairComponent from "./MenuSairComponent";

const NavigationSimpleComponent = (props: any) => {
	const clickMenu = () => {
		if (props.setToggleMenuCollapse != null)
		{
			props.setToggleMenuCollapse();
		}

		let menu = document?.getElementById('main-menu');
		if (menu == null) {
			return;
		}

		document.getElementById('sair-div')?.click();
		if (menu.classList.contains('expanded')) {
			menu.classList.remove('expanded');
			return;
		}

		menu.classList.add('expanded');
	};

	function hideSubMenus(e: any) {
		document.getElementById('main-menu')?.classList.remove('expanded');

		let classMenu = document.getElementsByClassName('menu-principal');
		for (var i = 0; i < classMenu.length; i++) {
			let subMenus = classMenu[i].getElementsByTagName('ul');
			if (subMenus != null) {
				for (var x = 0; x < subMenus.length; x++) {
					subMenus[x].style.display = 'none';
				}
			}

			for (var i = 0; i < classMenu.length; i++) {
				let iconSubMenus = classMenu[i].getElementsByTagName('i');
				if (iconSubMenus == null) {
					continue;
				}

				for (var x = 0; x < iconSubMenus.length; x++) {
					if (iconSubMenus[x].className.indexOf('up-down-arrow') >= 0) {
						iconSubMenus[x].className = 'fa fa-angle-down fa-2x up-down-arrow';
					}
				}
			}
		}
	}

	return (
		<div className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
			<a className="navbar-brand px-3 fs-6" href="#" onMouseLeave={hideSubMenus}>
				
				{/* <span style={{'backgroundColor': '#fff'}}> */}
				<img src="/Logo_C2_TOWER.svg" width={'200em'} style={{left: '20px'}} className="logo-main" />
					{/* <img src="/c2_logo_transparent.png" width={'40em'} />
					<span className="font-logo font-logo-1">2</span>
					<span className="font-logo font-logo-2">TOWER</span> */}
				{/* </span> */}
			</a>
		</div>
	);
}

export default NavigationSimpleComponent;